import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { welcomeContent, generalInfo, generalApproach } from './content';
import { Diagnosis, Case, PracticeCasesService } from '../services/practice-cases.service';

@Component({
  selector: 'app-content',
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.scss']
})
export class ContentComponent implements OnInit {
  @Output() navigate = new EventEmitter<{section: string, title: string, data?: any}>();
  
  // Default active section
  activeSection: string = 'welcome';
  welcomeContent = welcomeContent;
  generalInfo = generalInfo;
  generalApproach = generalApproach;
  loader=false;
  // Practice cases data
  currentCase: Case | null = null;
  diagnosisList: Diagnosis[] = [];
  allCases : Case[] = []
  selectedCase: Case | null = null;
  
  // Case explanation data
  explanationCaseId: number | null = null;

  constructor(private practiceCasesService: PracticeCasesService) { }

  ngOnInit(): void {
    // Initialize with empty data
  }

  // This method would be called from the parent component
  // when a navigation item is selected
  setActiveSection(section: string, data?: any): void {
    this.activeSection = section;
    
    if (data) {
      if (data.caseItem) {
        this.currentCase = data.caseItem;
      }
      
      if (data.diagnosisList) {
        this.diagnosisList = data.diagnosisList;
      }
      
      if (data.allCases) {
        this.allCases = data.allCases;
      }
      
      if (data.explanationCaseId) {
        this.explanationCaseId = data.explanationCaseId;
      }
    }
    
    // Load practice cases if navigating to list-of-cases and we don't have data yet
    if (section === 'list-of-cases' && this.allCases.length === 0) {
      this.loadPracticeCases();
    }
  }
  
  // Handle navigation events from the interactive-cases component
  onCaseNavigate(event: {section: string, title: string, data?: any}): void {
    // First update local state
    this.setActiveSection(event.section, event.data);
    
    // Then emit the event up to the parent component to update header
    this.navigate.emit(event);
  }
  
  // Load practice cases when needed
  private loadPracticeCases(): void {
    this.loader=true;
    this.practiceCasesService.getPracticeCases().subscribe((diagnosisList: Diagnosis[]) => {
      this.diagnosisList = diagnosisList;
      
      // Collect all cases
      let caseCounter = 1;
      this.allCases = [];
      
      diagnosisList.forEach((diagnosis: Diagnosis) => {
        diagnosis.cases.forEach((caseItem: Case) => {
          this.allCases.push({
            case_id: caseItem.case_id,
            case_title: caseItem.case_title,
            case_content: caseItem.case_content
          });
        });
      });
      this.loader=false;
    });
  }

  // Handle case selection
  selectCase(caseItem: Case): void {
    this.selectedCase = caseItem;
  }
  
  // Go back to the practice cases list
  goBackToCasesList(): void {
    // Navigate to practice cases tab
    this.activeSection = 'list-of-cases';
    this.currentCase = null;
  }
  
  // Go back to interactive cases list
  goBackToInteractiveCases(): void {
    this.activeSection = 'interactive-cases';
    this.explanationCaseId = null;
    
    // Update the header
    this.navigate.emit({
      section: 'interactive-cases',
      title: 'Interactive Cases'
    });
  }
}
